module.exports = __webpack_public_path__ + "img/rightIcon.875420f7.png";